import { render, staticRenderFns } from "./tempResvType.vue?vue&type=template&id=53c8ac08&scoped=true"
import script from "./tempResvType.vue?vue&type=script&lang=js"
export * from "./tempResvType.vue?vue&type=script&lang=js"
import style0 from "./tempResvType.vue?vue&type=style&index=0&id=53c8ac08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c8ac08",
  null
  
)

export default component.exports